'use strict';
(function () {
  var _controller = 'storeCart.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', 'flyer.resource', 'order.resource', 'productCategory.resource', 'product.resource', 'promotion.resource', 'callEmployee.resource', 'card.resource', 'points.resource', 'hq.socket', 'clubCard.resource', 'clubLevel.resource', 'clubBenefit.resource', '$q', 'storeUtils', '$timeout', 'posTable.resource', 'customInquery.resource', 'appRate.modal', 'pagouno.modal'];
  function controller($scope, flyerResource, orderResource, productCategoryResource, productResource, promotionResource, callEmployeeResource, cardResource, pointsResource, hqSocket, clubCardsResource, clubLevelResource, clubBenefitResource, $q, storeUtils, $timeout, posTableResource, customInqueryResource, appRateModal, pagounoModal) {
    /// Methods
    $scope.getMPData = getMPData;
    $scope.anotherProduct = anotherProduct;
    $scope.selectProduct = selectProduct;
    $scope.removeProduct = removeProduct;
    $scope.editProduct = editProduct;
    $scope.removeOrder = removeOrder;
    $scope.sendLocalPartialProducts = sendLocalPartialProducts;
    $scope.sendLocalTicketRequest = sendLocalTicketRequest;
    $scope.cashPay = cashPay;
    $scope.pointInputChange = pointInputChange;
    $scope.payWithPointsChange = payWithPointsChange;
    $scope.payOrder = payOrder;
    $scope.unselectOthers = unselectOthers;
    $scope.toggleContent = toggleContent;
    $scope.toggleBenefit = toggleBenefit;
    $scope.setTip = setTip;
    $scope.onLogin = onLogin;
    $scope.initLoggedInData = initLoggedInData;
    $scope.selectTable = selectTable;

    /// Vars
    /// En caso que se deba recuperar la orden, esto pasa cuando hay un REDIRECT, por ejemplo pagos con webpay
    /// si el pago falla, se debe recuperar la orden que fue guardada justo antes del redirect
    if (window.queryStrings && window.queryStrings.recoverOrder) {
      window.queryStrings.recoverOrder = undefined;
      $scope.$root.currentOrder = JSON.parse(window.appStorage.get('storeCartRecoveryOrder'));
      $scope.$root.defaultRouter = $scope.$root.currentOrder.router;
      ons.notification.alert({
        title: i18next.t('Problema con el pago'),
        message: i18next.t(window.queryStrings.payError ? atob(window.queryStrings.payError) : i18next.t('Error no especificado'))
      });
    }

    var currentOrder = $scope.$root.currentOrder;

    $scope.$root.currentOrder.router = $scope.$root.defaultRouter;
    $scope.router = $scope.$root.routers.filter(function (f) { return f._id === $scope.$root.defaultRouter })[0]
    //if ($scope.$root.currentOrder.checkoutMethod === 'DELIVERY') $scope.$root.currentOrder.delivery = true;
    $scope.quantity = 1;
    $scope.cardData;
    $scope.showCashPay = false;
    $scope.showCardPay = false;
    $scope.localPartialSend = false;
    $scope.tips = [];
    $scope.scheduleHours = []
    var cashByPointsPromise;

    /// Watchers
    $scope.$on('$destroy', onDestroy.bind(null, _controller));
    if ($scope.$root.currentOrder.checkoutMethod === 'LOCAL') {
      hqSocket.on('ORDER_UPSERT', getPreviewOrder);
    }

    /// Init
    init();

    /////////////////////////////////////////////////

    function init(){
      if(profile._id){
        initLoggedInData();
      }
      setPaymentsMethods();
      getPreviewOrder();
      processAdditionalInfos();
      refreshProducts();
      refreshPromotions();
      getScheduleHours();
      tipsSetup()
      getTables();
    }

    function onLogin(){
      initLoggedInData();
      getPreviewOrder();
    }

    function initLoggedInData(){
      setClubBenefitGroups();
      getCashPoints();
      saveCustomInqueryResponses();
      setClientToNewProducts();
      $scope.points = pointsResource.query({ router: $scope.$root.currentOrder.router, _controller: _controller })
      $scope.cards = cardResource.query({ _controller: _controller }, function (data) { })
    }

    function anotherProduct() {
      appNavigator.resetToPage('store/storeProductSelection/storeProductSelection.jade', { data: { onClose: Function.Prototype } });
    }

    function setPaymentsMethods() {
      var payMethods = $scope.router.pwaPaymentMethods;
      var currentMethod = $scope.$root.currentOrder.checkoutMethod;
      /// cash y card global apagan cualquiera
      if (currentMethod === 'DELIVERY') {
        $scope.showCashPay = payMethods.deliveryCash && payMethods.cash;
        $scope.showCardPay = payMethods.deliveryCard && payMethods.card;
      }
      else if (currentMethod === 'TAKEAWAY') {
        $scope.showCashPay = payMethods.takeAwayCash && payMethods.cash;
        $scope.showCardPay = payMethods.takeAwayCard && payMethods.card;
      }
      else if (currentMethod === 'LOCAL') {
        $scope.showCashPay = payMethods.localCash && payMethods.cash;
        $scope.showCardPay = payMethods.localCard && payMethods.card;
      }
      else if (currentMethod === 'AUTOSERVICE') {
        $scope.showCashPay = payMethods.autoserviceCash && payMethods.cash;
        $scope.showCardPay = payMethods.autoserviceCard && payMethods.card;
      }
    }

    function refreshPromotions() {
      promotionResource.query({ _controller: _controller, 'target.pwa': true, router: $scope.$root.defaultRouter }, function (promotions) {
        promotions.forEach(function (p) {
          if (p.match && p.match.cash && p.discount) {
            if (p.discount.type === 'FIXED')
              $scope.cashPromotion = '$' + p.discount.value;
            else if (p.discount.type === 'PERCENT')
              $scope.cashPromotion = p.discount.value * 100 + '%' + ' OFF'
          }
        })
        $scope.productsWithCashPromotion = $scope.$root.currentOrder.products.find(function (p) { return p.properties.promotionPriceOnlyCash });
      })
    }

    function onDestroy(_controller) {
      hqSocket.removeListener('ORDER_UPSERT', getPreviewOrder)
      $scope.$root.abortRequests(_controller);
      $timeout.cancel(approvalTimeout);
    }

    function processAdditionalInfos() {
      $scope.additionalInformations = [];
      $scope.$root.currentOrder.products.forEach(function (m) {
        if (m.additionalInformation)
          $scope.additionalInformations = $scope.additionalInformations.concat(m.additionalInformation)
      })
    }

    function getPreviewOrder(data) {
      // Busco el order en el api
      // currentOrder se crea en la vista personalizeProduct
      // Voy a pedir un preview al backend para unificar la lógica de cálculo de totales
      $scope.$root.currentOrder._controller = _controller;
      $scope.$root.currentOrder.preview = true;

      if (data && $scope.$root && $scope.$root.currentOrder && $scope.$root.currentOrder._id === data) {
        if ($scope.$root.currentOrder.checkoutMethod === 'LOCAL') {
          orderResource.get({ _controller: _controller, _id: data, _select: ['queue.status', 'table', 'secondaryClients.*'] }, function (order) {
            /// Actualizo la mesa si la cambiaron desde backend
            if (order.table !== $scope.$root.currentOrder.table) {
              $scope.$root.currentOrder.table = order.table;
              return;
            }
            if (order.queue && !order.queue.status) {
              ons.notification.alert({
                title: i18next.t('Mesa cerrada'),
                message: i18next.t('La mesa fue cerrada, para volver a abrirla, debe escanear de nuevo el código QR. Si abre la tienda nuevamente, preste atención al método de entrega, en la parte superior.')
              });
              window.queryStrings.table = undefined;
              $scope.$root.currentOrder = undefined;
              $scope.$root.openSection('home/home.jade')
            }
            if (order.queue && order.queue.status === 'IN-PROGRESS') {
              ons.notification.toast(i18next.t('Su orden fue aprobada'), { timeout: 2000 })
              appNavigator.resetToPage('storeProductSelection/storeProductSelection.jade');
            }
          })
        }
      }

      if (false && $scope.$root.currentOrder.checkoutMethod === 'LOCAL') {
        orderResource.get({ _id: $scope.$root.currentOrder._id, _controller: _controller, _select: ['*'] }, function (dbOrder) {
          $scope.currentOrder.products = $scope.$root.currentOrder.products.filter(function (f) {
            /// Solo deberían estar en mi orden, productos que vinieron de db mas productos recién agregados
            /// Dicho de otra manera, borro aquellos productos que no son nuevos y que no están mas en la orden de backend
            /// Esto puede darse cuando un empleado borra un producto desde el panel de admin
            if (f._new) return true;
            if (dbOrder.products.filter(function (k) { return k.frontendIndex === f.frontendIndex }).length) return true;
            else return false
          })
          orderResource.save($scope.$root.currentOrder, processPreviewOrder)
        })
      }
      else {
        orderResource.save($scope.$root.currentOrder, processPreviewOrder)
      }
    }

    function processPreviewOrder(previewOrder) {
      $scope.backendOrder = previewOrder;
      if(cashByPointsPromise) cashByPointsPromise.then(processCashPoints)
      previewOrder._subtotal = 0;
      previewOrder.products.forEach(function (p) {
        var ramProduct = $scope.$root.currentOrder.products.find(function (f) { return f.frontendIndex === p.frontendIndex });
        p._new = ramProduct ? ramProduct._new : false;
        if (p._new) $scope.localPartialSend = true;
        previewOrder._subtotal += (p.totalPrice * p.quantity)
      })

      /// Si todos los productos son voucher no se puede pagar en efectivo
      if (previewOrder.products.filter(function (f) { return f.properties && f.properties.cardTemplate }).length === previewOrder.products.length)
        $scope.showCashPay = false;

      if(previewOrder.checkoutMethod === 'LOCAL')
        previewOrder.products.sort(function(a,b){
          if(!a.client || !b.client) return 0;
          if(a.client.name === b.client.name) return new Date(a.ts) - new Date(b.ts);
          return a.client.name > b.client.name ? 1 : -1
        })

      $scope.amountByClient = getAmountByClient(previewOrder);

    }


    function getAmountByClient(order){
      var amountByClient = [];
      order.products.forEach(function(product){
        if(!product.client) return;
        var client = amountByClient.find(function(f){return f._id === product.client._id})
        if(!client){
          client = {_id: product.client._id, name: product.client.name, amount: 0};
          amountByClient.push(client);
        }
        client.amount += product.totalPrice * product.quantity;
      })

      var totalDiscounts = order.discounts.reduce(function(acc, discount){return acc += discount.price}, 0);
      var totalExtraCharges = order.extraCharges.reduce(function(acc, extra){return acc += extra.totalPrice}, 0);

      amountByClient.forEach(function(client){
        client.amount -= totalDiscounts / amountByClient.length;
        client.amount += totalExtraCharges / amountByClient.length;
      })

      return amountByClient;
    }

    function removeProduct(product) {
      //// Notar que se usa la bandera frontendIndex que va al servidor y luego vuelve
      $scope.$root.currentOrder.products.splice($scope.$root.currentOrder.products.findIndex(function (f) { return f.frontendIndex === product.frontendIndex }), 1);
      if (!$scope.$root.currentOrder.products.length) return anotherProduct()
      getPreviewOrder();
    }

    function editProduct(product) {
      var currentProduct = $scope.$root.currentOrder.products.find(function (f) { return f.frontendIndex === product.frontendIndex })
      window.appNavigator.pushPage('store/storeProductPersonalization/storeProductPersonalization.jade', {
        data: { product: currentProduct, onClose: function () { getPreviewOrder() } }
      });
    }

    function removeOrder() {
      $scope.$root.currentOrder.products = [];
      anotherProduct();
    }

    function getMPData() {
      if (!canPay()) return;
      $scope.$root.currentOrder.expectedPay = undefined;
      $scope.$root.currentOrder.payByCard = true;
      $scope.$root.currentOrder.cash = false;
      var gateway = $scope.router.paymentGateway || 'MERCADOPAGO-AR';
      if (['TRANSBANK-WEBPAY-MALL', 'PAGOS360'].includes(gateway)) {
        showConfirmationButton();
        getPreviewOrder();
        showBuyMessage('PRE-CONFIRMATION');
        return
      }
      if (gateway === 'MERCADOPAGO-AR')
        return appNavigator.pushPage('mercadoPagoByApi/mercadoPagoByApi.jade', {
          data: {
            amount: $scope.backendOrder.totalPrice,
            comment: '',
            onlyPayData: true,
            onClose: function (data) {
              $scope.cardData = data;
              showConfirmationButton();
              getPreviewOrder();
              showBuyMessage('PRE-CONFIRMATION');
            }
          }
        });
      else if (gateway === 'PAGOUNO')
        pagounoModal.open({
          amount: $scope.backendOrder.totalPrice,
          router: $scope.backendOrder.router
        }).then(function(data){
          if(!data) return;
          $scope.cardData = data;
          showConfirmationButton();
          getPreviewOrder();
          showBuyMessage('PRE-CONFIRMATION');
        })
    }


    function showConfirmationButton(){
      $scope.confirmation = true;
      $('.scroller-div').animate({ scrollTop: 0 }, 700);
    }

    function refreshProducts() {
      productCategoryResource.query({ _controller: _controller }, function (data) {
        $scope.categories = data;
        productResource.query({
          _controller: _controller,
          router: $scope.$root.defaultRouter,
          _select: ['properties', 'masterProduct']
        }, function (data) {
          $scope.allProducts = data
          /// Hago links imgs
          data.forEach(function (e) {
            if (!e._image) Object.defineProperty(e, '_image', { writable: true });
            e._image = '/progressiveApp/api/productMedia?product=' + e.masterProduct + '&enterprise=' + window.enterprise;
          })
          $scope.categories.forEach(function (category) {
            category.products = $scope.allProducts.filter(function (f) { return f.properties && f.properties.categories && f.properties.categories.find(function (d) { return d._id === category._id }) })
          })
          var recommendationsCategory = $scope.categories.filter(function (f) { return f.name === 'Recomendados' })
          if (recommendationsCategory.length) {
            $scope.recommendations = recommendationsCategory[0].products;
            $scope.recommendations = $scope.recommendations.filter(function (p) {
              return !$scope.$root.currentOrder.products.filter(function (pf) { return p._id === pf._id }).length;
            })
          }
        })
      })
    }

    function selectProduct(product) {
      window.appNavigator.resetToPage('store/storeProductPersonalization/storeProductPersonalization.jade', {
        data: { productId: product._id, onClose: Function.Prototype }
      });
    }

    function cashPay() {
      if (!canPay()) return;
      /// avoidExpectedPayPrompt salta el cartel de con cuanto desea abonar
      if($scope.router && $scope.router.avoidExpectedPayPrompt && $scope.backendOrder.totalPrice) {
        $scope.$root.currentOrder.expectedPay = 0;
        _cashPay();
      }
      else
        ons.notification.prompt({
          message: i18next.t('¿Con cuanto tenés pensado abonar tu pedido? <br> ( total a pagar $') + $scope.backendOrder.totalPrice.toFixed(2) + i18next.t(' )'),
          title: i18next.t('Pagar en efectivo'),
          inputType: 'number',
          cancelable: true
        }).then(function (val) {
          if (!val) return;
          if (val < $scope.backendOrder.totalPrice) return ons.notification.alert({ title: 'Error', message: 'No puede abonar un monto inferior al total' });
          $scope.$root.currentOrder.expectedPay = val;
          _cashPay()
        })
    }

    function _cashPay(){
      $scope.$root.currentOrder.cash = true;
      $scope.$root.currentOrder.payByCard = false;
      $scope.cardData = undefined;
      $scope.$root.currentOrder._controller = _controller;
      showConfirmationButton()
      getPreviewOrder();
      showBuyMessage('PRE-CONFIRMATION');
    }

    function canPay() {
      var currentOrder = $scope.$root.currentOrder;

      if ((currentOrder.checkoutMethod === 'AUTOSERVICE' || currentOrder.checkoutMethod === 'LOCAL') && $scope.tables.length && !$scope.$root.currentOrder.table){
        ons.notification.alert(i18next.t('Por favor, seleccione una mesa para continuar'), { title: 'Mesa obligatoria' });
        document.getElementById('tableSelection').scrollIntoView()
        return false;
      }

      /// Se calcula el minOrder teniendo en cuenta que algunos descuentos pueden reducir minOrder
      var minOrder = $scope.router.pwaMinOrder;
      // caso REDUCE
      if (minOrder && $scope.backendOrder.discounts)
        minOrder -= $scope.backendOrder.discounts.reduce(function (acum, disc) { return acum + (disc.reduceMinOrderBy || 0) }, 0);

      // caso IGNORE
      if ($scope.backendOrder.discounts.reduce(function (acum, disc) { return acum + (disc.ignoreMinOrder || 0) }, 0))
        minOrder = 0;

      if (minOrder < 0) minOrder = 0;

      //// COMPRA MINIMA
      if (minOrder > $scope.backendOrder.totalPrice) {
        ons.notification.alert({ title: 'Advertencia', message: 'La orden debe superar los ' + '$' + minOrder });
        return false
      }

      /// OVERRIDES
      if ($scope.router.overrides && $scope.router.overrides.disableStore) {
        ons.notification.alert(i18next.t('Lo sentimos, por el momento tuvimos que cerrar el local'), { title: 'Problema' });
        return false
      }
      if ($scope.router.overrides &&
        ($scope.$root.currentOrder.checkoutMethod === 'TAKEAWAY' && $scope.router.overrides.disableTakeaway ||
          $scope.$root.currentOrder.checkoutMethod === 'DELIVERY' && $scope.router.overrides.disableDelivery)) {
        ons.notification.alert(i18next.t('Lo sentimos, por el momento tuvimos que cerrar el tipo de entrega seleccionado'), { title: 'Problema' });
        return true;
      }
      return true;
    }

    function payOrder() {
      /// Datos de la tarjeta
      if (!canPay()) return;
      if ($scope.cardData) {
        if ($scope.cardData.saveCard) {
          $scope.$root.currentOrder.payData = $scope.cardData;
          $scope.$root.currentOrder.saveCard = $scope.cardData.saveCard;
        }
        $scope.$root.currentOrder.token = $scope.cardData.token;
        $scope.$root.currentOrder.paymentMethodId = $scope.cardData.paymentMethodId;
        $scope.$root.currentOrder.name = $scope.cardData.cardholderName
      }
      $scope.$root.currentOrder.email = profile.email;
      $scope.$root.currentOrder.preview = false;
      $scope.$root.currentOrder._controller = _controller;

      //// Si se programó el envío
      if ($scope.scheduleHours && $scope.scheduleHours.length)
        $scope.$root.currentOrder.scheduleData = $scope.scheduleHours.find(function (f) { return f.selected && f.from })

      $scope.$root.currentOrder._ignoreError = true;
      $scope.savingOrder = orderResource.save($scope.$root.currentOrder, function (payedOrder) {
        /// PARA PAGOS CON REDIRECT (webpay)
        if (payedOrder.paymentResult && payedOrder.paymentResult.status === 'REDIRECT') {
          if (!payedOrder.paymentResult.redirectUrl) throw new PentaError('No se puede redirecccionar')
          appStorage.set('storeCartRecoveryOrder', JSON.stringify($scope.$root.currentOrder));
          window.location.href = payedOrder.paymentResult.redirectUrl
          return;
        }

        /// PARA OTROS
        if ($scope.$root.currentOrder.checkoutMethod !== 'LOCAL') {
          if (!$scope.$root.ordersInProcess) $scope.$root.ordersInProcess = [];
          //// Este timeout lo hago para que no se rompa la vista por un segundo, no usar para LOCAL
          setTimeout(function () {
            $scope.$root.currentOrder = null;
          }, 1000)
          $scope.$root.ordersInProcess.push(payedOrder)
          showBuyMessage('POST-CONFIRMATION');
          appNavigator.pushPage('store/storeTracking/storeTracking.jade', { data: { order: payedOrder, onClose: Function.Prototype } });
          /// PARA LOCAL
        } else {
          /// Elimino la currentOrder para que la vista de productSelection la vuelva a pedir
          if ($scope.$root.currentOrder.payByCard)
            ons.notification.alert({
              message: i18next.t('Debe esperar a que el personal traiga el ticket a la mesa antes de retirarse'),
              title: 'Pago realizado correctamente'
            }).then(function () {
              showBuyMessage('POST-CONFIRMATION')
              $scope.$root.currentOrder = null;
              $scope.$root.openSection('store/storeProductSelection/storeProductSelection.jade', {
                data: {
                  onClose: Function.Prototype,
                }
              });
            })
          else
            ons.notification.alert(i18next.t('Los productos fueron pedidos correctamente. El personal de atención se acercará para corroborar la orden'), {
              title: 'Enviado'
            }).then(function () {
              $timeout(function(){appRateModal.open('localProductAdded')}, 2000);
              $scope.$root.currentOrder = null;
              $scope.$root.openSection('store/storeProductSelection/storeProductSelection.jade', {
                data: {
                  onClose: Function.Prototype,
                  localProductsAdded: true
                }
              });
            })
        }
      }).$promise.catch(function(err){
        if(err.data && err.data.message === '7152') {
          $scope.waitingTableApproval = true;
          monitorTableApproval()
        }
        else throw new PentaError(err.data)
      })
    }

    var approvalTimeout;
    function monitorTableApproval(){
      if($scope.waitingTableApproval)
        approvalTimeout = $timeout(function(){
          orderResource.query({ _controller: _controller, _select: ['*'], checkoutMethod: 'LOCAL', 'queue.status_ne': 'null' }, function(orders){
            if(orders && orders.length){
              orders[0].products = orders[0].products.concat($scope.$root.currentOrder.products);
              $scope.$root.currentOrder = orders[0];
              $scope.waitingTableApproval = false;
              getPreviewOrder();
              $('.scroller-div').animate({ scrollTop: 0 }, 700);
              ons.notification.alert({
                title: i18next.t('Aprobado'),
                message: i18next.t('Ya puedes enviar el pedido'),
              })
            }
            else
              monitorTableApproval()
          })
        }, 5000)
    }

    function sendLocalPartialProducts() {
      $scope.$root.currentOrder.cash = true;
      $scope.cardData = undefined;
      $scope.$root.currentOrder._controller = _controller;
      payOrder();
    }

    function toggleContent(content, $event) {
      if (!content) return;
      /// Evito que se destilde cuanto toca el input
      if ($event && $event && event.target && event.target.type === 'number') return;
      var usedCard = null;
      //// Solo permito elegir un contenido
      $scope.cards.forEach(function (card) {
        if (!card.cardTemplate || !card.cardTemplate.content || !card.cardTemplate.content.length) return;
        card.cardTemplate.content.forEach(function (c) {
          if (c === content) {
            c.selected = !c.selected;
            usedCard = card;
          }
          else
            c.selected = false;
        })
      })
      /// inicializo usePoints
      if (content.type === 'POINTS' && !content.usePoints) content.usePoints = content.total;
      $scope.$root.currentOrder.cardContents = content.selected ? [{ card: usedCard._id, content: content._id, usePoints: content.usePoints }] : undefined;
      getPreviewOrder();
    }

    function toggleBenefit(benefit, $event) {
      if (!benefit) return;
      /// Evito que se destilde cuanto toca el input
      if ($event && $event && event.target && event.target.type === 'number') return;
      //// Solo permito elegir un contenido
      $scope.benefitGroups.forEach(function (group) {
        if (!group.benefits || !group.benefits.length) return;
        group.benefits.forEach(function (c) {
          if (c === benefit) {
            c.selected = !c.selected;
          }
          else
            c.selected = false;
        })
      })
      /// inicializo usePoints
      if (benefit.content.type === 'POINTS' && !benefit.content.usePoints) benefit.content.usePoints = benefit.content.amount;
      $scope.$root.currentOrder.clubBenefits = benefit.selected ? [{ clubBenefit: benefit._id, usePoints: benefit.content.usePoints }] : undefined;
      getPreviewOrder();
    }

    function pointInputChange(content) {
      if (content.usePoints > content.total) content.usePoints = content.total;
      if (content.usePoints <= 0) content.usePoints = 1;
      if ($scope.$root.currentOrder.cardContents && $scope.$root.currentOrder.cardContents.length) {
        $scope.$root.currentOrder.cardContents.forEach(function (cardContent) {
          if (cardContent.content === content._id) {
            cardContent.usePoints = content.usePoints;
          }
        })
        getPreviewOrder();
      }
    }

    function payWithPointsChange(order) {
      if (order.payWithPoints > $scope.cashByPoints) order.payWithPoints = Math.floor($scope.cashByPoints);
      getPreviewOrder()
    }

    function getScheduleHours() {
      var order = $scope.$root.currentOrder;
      var hours;

      if (order.checkoutMethod === 'TAKEAWAY')
        hours = !$scope.router.takeAwayAutoSchedule && $scope.router.takeAwayScheduleHours;
      else if (order.checkoutMethod === 'DELIVERY') {
        var area = $scope.router.deliveryAreas.find(function (f) { return f._id === order.deliveryArea && !f.autoSchedule });
        if (area) hours = area.scheduleHours;
      }
      if (!hours || !hours.length) return;
      var date

      ///// scheduleForNextOpened se define en productSelection.controller y es el horario de apertura mas cercano
      if (order.scheduleForNextOpened) {
        order.scheduleForNextOpened.selected = true;
        order.scheduleForNextOpened.today = order.scheduleForNextOpened.from.getDate() === (new Date()).getDate();
        order.scheduleForNextOpened.tomorrow = order.scheduleForNextOpened.from.getDate() === (moment().add('days', 1)).date();
        $scope.scheduleHours.push(order.scheduleForNextOpened)
      }
      else
        $scope.scheduleHours.push({ selected: true })
      for (var i = 0; i < 10; i++) {
        date = moment();
        date.add('days', i);
        hours.forEach(function (hour) {
          if (hour.dow !== date.day()) return;
          //// Hasta una hora antes del segmento se puede programar
          var openHour = moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: hour.openHour }).toDate();
          if (i === 0 && Date.now() > (hour.openHour - 1000 * 60 * 60 * 2)) return;
          $scope.scheduleHours.push({
            today: i === 0,
            tomorrow: i === 1,
            from: openHour,
            to: moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: hour.closeHour }).toDate()
          })
        })
      }
    }

    function unselectOthers(array, item) {
      array.forEach(function (a) {
        if (a !== item) a.selected = false
      })
    }

    function setClubBenefitGroups() {
      var promises = [
        clubCardsResource.query({ _controller: _controller }, function (data) { }).$promise,
        clubLevelResource.get({ _controller: _controller }, function (data) { }).$promise
      ]
      $q.all(promises)
        .then(function (data) {
          var clubCards = data[0]
          var clubLevelInfo = data[1]
          $scope.benefitGroups = [];
          /// Beneficios del nivel
          if (clubLevelInfo && clubLevelInfo.currentLevel)
            $scope.benefitGroups.push({
              benefits: clubLevelInfo.currentBenefits,
              title: i18next.t('Beneficios por nivel') + ': ' + clubLevelInfo.currentLevel.name
            })
          /// Beneficios de tarjetas
          if (clubCards && clubCards.length)
            $scope.benefitGroups = $scope.benefitGroups.concat(clubCards.map(function (m) {
              return {
                benefits: m.benefits,
                title: m.clubCardTemplate ? m.clubCardTemplate.name : i18next.t('Otros beneficios')
              }
            }))

          /// Solo grupos que tengan beneficios
          $scope.benefitGroups = $scope.benefitGroups.filter(function (f) { return f.benefits && f.benefits.length });
          /// Solo grupos que no tengan beneficios manuales
          $scope.benefitGroups = $scope.benefitGroups.filter(function (f) {
            return f.benefits && f.benefits.length && f.benefits.find(function (b) {
              return !b.content || (b.content.type && b.content.type !== "MANUAL-IMPLEMENTATION");
            })
          })
          /// FILTRO LOS TIPOS QUE CORRESPONDEN AL STORE
          $scope.benefitGroups.forEach(function (group) {
            group.benefits = group.benefits.filter(function (f) {
              if (!f.content) return false;
              return ['PRODUCTS', 'STORE-ORDER-DISCOUNT', 'STORE-DELIVERY-DISCOUNT'].includes(f.content.type)
            })
          })

        })
        .catch(function () { })
    }

    function sendLocalTicketRequest() {
      ons.notification.confirm({ message: i18next.t('¿Seguro que quiere pedir la cuenta?'), title: i18next.t('Pedir cuenta'), cancelable: true }).then(function (result) {
        if (result < 1) return;
        callEmployeeResource.save({
          router: $scope.$root.currentOrder.router,
          table: $scope.$root.currentOrder.table,
          type: 'TABLE-NEEDS',
          needText: 'ticket'
        }, function () {
          ons.notification.alert(i18next.t('El personal de atención se acercará a la brevedad'), { title: 'Cuenta solicitada' }).then(function () {
            appNavigator.pushPage('nps/nps.jade', {
              data: {
                router: $scope.$root.currentOrder.router,
                order: $scope.$root.currentOrder._id,
                origin: 'STORE',
                onClose: function () {
                  appNavigator.resetToPage('storeProductSelection/storeProductSelection.jade');
                }
              },
            })
          })
          showBuyMessage('POST-CONFIRMATION')
        })
      })
    }

    function getCashPoints() {
      cashByPointsPromise = clubBenefitResource.get({ cashByPoints: true, router: $scope.$root.currentOrder.router }).$promise
    }

    function processCashPoints (data) {
      return;
      var max;
      if (profile.enterprise.pwaConfig.storeConfig) {
        var maxType = profile.enterprise.pwaConfig.storeConfig.maxCashWithPointsType;
        var maxValue = profile.enterprise.pwaConfig.storeConfig.maxCashWithPointsValue;
        if (maxType === 'FIXED') max = maxValue;
        else if (maxType === 'PERCENT') max = maxValue * $scope.backendOrder.totalPrice;
        else max = undefined;
      }
      $scope.cashByPoints = max ? Math.min(data.totalCash, max) : data.totalCash;
    }

    function showBuyMessage(moment) {
      //- Obtengo Alertas PRE-CONFIRMATION.
      var alerts = storeUtils.filterBuyMessage($scope.router.showBuyMessage, moment);
      //- Verifico cada Alerta si matchea, en caso afirmativo muestro dicha alerta.
      alerts.forEach(function (f) {
        if (!storeUtils.doesMatch($scope.$root.currentOrder, f)) return
        storeUtils.showBuyMessage(f);
      })
    }

    function tipsSetup() {
      if (!$scope.router || !$scope.router.tips || !$scope.router.tips.length || !$scope.$root.currentOrder) return
      var currentOrder = $scope.$root.currentOrder; //- orden actual.
      //- filtro las propinas que coincidan con el checkoutMethod y esten activas ( selected )
      $scope.tips = $scope.router.tips.filter(function (f) {
        return (f.checkoutMethod === currentOrder.checkoutMethod || f.checkoutMethod === 'ALL')
      });
      //- si no hay tips en el router Retorna.
      if (!$scope.tips || !$scope.tips.length) return

      if (!currentOrder.tip) {
        var defaultTip = $scope.tips.find(function(f){return f.selected});
        if(!defaultTip) defaultTip = $scope.tips[0];
        setTip(defaultTip);
      }
    }

    function setTip(tip) {
      if (!tip || !tip._id) return
      $scope.$root.currentOrder.tip = tip;
      $scope.tips.forEach(function (f) { f.selected = false })
      tip.selected = true;
      getPreviewOrder();
    }

    function getTables(){
      if(currentOrder.checkoutMethod === 'AUTOSERVICE' || currentOrder.checkoutMethod === 'LOCAL')
        posTableResource.query({router: currentOrder.router}, function(tables){
          $scope.tables = tables;
          if($scope.$root.currentOrder.table) {
            var selTable = tables.find(function(f){return f._id === $scope.$root.currentOrder.table})
            if(selTable) selTable.selected = true;
          }
        })
    }

    function saveCustomInqueryResponses(){
      /// Esta variable se setea en productSelection.controller en caso de que el usuario no haya hecho login
      /// Esto es para que las respuestas se guarden al hacer login en este punto
      if($scope.$root.currentOrder.customInqueryResponses)
        $q.all($scope.$root.currentOrder.customInqueryResponses.map(function(r){ return customInqueryResource.save(r).$promise }))
          .then(function(){
            $scope.$root.currentOrder.customInqueryResource = undefined;
          })
          .catch(function(){ 
            $scope.$root.currentOrder.customInqueryResource = undefined;
          })
    }

    function setClientToNewProducts(){
      $scope.$root.currentOrder.products.forEach(function(p){
        if(p._new) p.client = {
          _id: profile._id,
          name: profile.name
        }
      })
    }

    function selectTable(array, table){
      array.forEach(function (a) {
        if (a !== table) a.selected = false
      })
      $scope.$root.currentOrder.table = table.selected ? table._id : undefined;
    }
  }
})();
